import type { RefObject } from 'react';

interface MenuItemRefs {
  elementRef?: RefObject<HTMLElement | null>;
  backgroundRef?: RefObject<HTMLDivElement | null>;
  lineRef?: RefObject<HTMLHRElement | null>;
}

// export function setupTransitionInTimeline(
//   timeline: gsap.core.Timeline,
//   { lineRef }: MenuItemRefs,
// ): void {
//   // if (lineRef?.current) {
//   //   timeline.fromTo(
//   //     lineRef.current,
//   //     { scaleX: 0, transformOrigin: 'left center' },
//   //     { duration: 0.5, ease: 'Quad.easeInOut', scaleX: 1 },
//   //   );
//   // }
// }

export function setupMouseEnterTimeline(
  timeline: gsap.core.Timeline,
  { backgroundRef }: MenuItemRefs,
): void {
  if (backgroundRef?.current) {
    timeline.fromTo(
      backgroundRef.current,
      { scaleY: 0 },
      { duration: 0.4, ease: 'Expo.easeOut', scaleY: 1 },
    );
  }
}

export function setupMouseLeaveTimeline(
  timeline: gsap.core.Timeline,
  { backgroundRef }: MenuItemRefs,
): void {
  if (backgroundRef?.current) {
    timeline.to(backgroundRef.current, { duration: 0.4, ease: 'Expo.easeOut', scaleY: 0 });
  }
}
